//
//
//
//
//
//
//
//
//
//
//
//

import mixins from './mixins'
import { cdn } from 'fangchan-base'
export default {
    mixins: [
        mixins
    ],
    components: {
    },
    data () {
        return {
            point:'',
            date:''
        }
    },
    methods: {
        start () {
            wx.navigateTo({
                url: `/pages/packageA/residence_points/exam`
            })
        },
        async getCDNData(){
            const { request } = cdn
            const getResidencePoint = () => request('pages/packageA/residence_points/config')
            const { point, date } = await getResidencePoint()
            this.point = point
            this.date = date
        }
    },
    async onLoad(){
        this.getCDNData()
    }
}
